'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  colors: {
    primary: '#F28000',
    // orange
    orange: '#F28000',
    secondary: '#6E0AD6',
    // purple
    purple: '#6E0AD6',
    purpleMedium: '#B684EA',
    clear: '#ffffff',
    white: '#ffffff',
    dark: '#4A4A4A',
    graphite: '#4A4A4A',
    lightBlue: '#E8F2FB',
    blue: '#28B5D9',
    brown: '#CA6D2F',
    lightGreen: '#00CBA4',
    green: '#10CE64',
    red: '#FF4444',
    yellow: '#F9AF27',
    grayscale: {
      background: '#F6F6F6',
      light: '#F9F9F9',
      regular: '#E5E5E5',
      dark: '#D2D2D2',
      darker: '#999999'
    }
  },
  spacings: {
    nugget1: 2,
    nugget2: 4,
    nugget3: 8,
    nugget4: 16,
    nugget5: 24,
    nugget6: 32,
    nugget7: 48,
    nugget8: 64,
    nugget9: 128
  },
  /* breakpoints in px for styled-components-breakpoints and for design-system usage */
  breakpoints: {
    xs: 0,
    sm: 400,
    md: 600,
    lg: 720,
    xl: 840
  },
  /* Grid config */
  awesomegrid: {
    columns: {
      xs: 4,
      sm: 4,
      md: 8,
      lg: 8,
      xl: 12
    },
    gutterWidth: {
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1.5,
      xl: 1.5
    },
    paddingWidth: {
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1.5,
      xl: 1.5
    },
    /* breakpoints in rem for grid */
    breakpoints: {
      xs: 1,
      sm: 25,
      md: 37.5,
      lg: 45,
      xl: 52.5
    }
  }
};